import React from "react";
import { Col, Row } from "../../../../common/grid";
import FileIcon from "../../../../common/fileIcon/FileIcon";
import "./DownloadModalContent.css";

/**
 * ATTACHMENT TYPES
 * 1 - Description attachment
 * 2 - Proposal Attachment
 * 3 - Budget Attachment
 * 4 - Document Attachment
 * 5 - Concept note attachment
 * 6 - Contract attachment
 * 7 - Photos attachment
 * 8 - Purchases attachment
 */

export const DownloadModalContent = ({ attachments }) => {
	return (
		<Col _bottom-32 download-modal-content>
			<h1>Documents attachments</h1>

			<Col>
				<Row _no-grow-last title-row>
					<div>Name</div>
					<div>File type</div>
				</Row>

				{attachments.map(a => (
					<a href={a.url} download>
						<Row
							_no-grow-last
							_no-grow-first
							_align-center
							_gap-8
							data-row
							key={a.id}
						>
							<FileIcon fileType={a.url.split(".").slice(-1)[0]} size={18} />
							<div>
								{a.file_name.length > 50
									? a.file_name.slice(0, 50) + "..."
									: a.file_name}
							</div>
							<div>.{a.url.split(".").slice(-1)[0]}</div>
						</Row>
					</a>
				))}
			</Col>
		</Col>
	);
};

export default DownloadModalContent;



// WEBPACK FOOTER //
// ./src/components/main/projects/_common/DownloadModalContent.js